export enum DeliveryOrderEventType {
    ORDERED = 'ordered',
    PICKUP = 'pickup',
    DELIVERY = 'delivery',
}
